module.exports = __webpack_public_path__ + "img/icon_zlxf.d71e719f.png";